class SearchBarA11y {
  constructor(container) {
    this.container = container;
    this.wrapper = container.closest('.header__search-desktop') || container.parentElement;
    this.input = container.querySelector('input[type="search"]');
    this.form = container.querySelector('form');
    this.resultsContainer = document.querySelector('.search-results--container');
    this.liveRegion = document.querySelector('[data-search-live-region]');
    this.defaultSuggestions = this.resultsContainer && this.resultsContainer.querySelector('.main-container-suggestion');
    this.dynamicResults = this.resultsContainer && this.resultsContainer.querySelector('.results-container-suggestion');
    this.searchBtn = document.querySelector('.search-bar-button');
    this.closeBtn = document.querySelector('.close-button-search-bar');
    this.siteHeader = document.querySelector('.site-header');
    this.currentIndex = -1;

    if (!this.input || !this.resultsContainer) return;

    this.setupAttributes();
    this.setupEventListeners();
    this.initObserver();
  }

  initObserver() {
    var self = this;
    if (!this.resultsContainer) return;
    this.observer = new MutationObserver(function() {
      self.refreshOptions();
    });
    this.observer.observe(this.resultsContainer, { childList: true, subtree: true });
  }

  getSelectableOptions() {
    if (!this.resultsContainer) return [];
    var items = this.resultsContainer.querySelectorAll('a, button');
    var result = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.closest('.close-button-search-bar')) continue;
      if (!item.closest('.search-results--container')) continue;
      result.push(item);
    }
    return result;
  }

  refreshOptions() {
    var options = this.getSelectableOptions();
    this.currentIndex = -1;

    for (var i = 0; i < options.length; i++) {
      if (!options[i].id) options[i].id = 'search-option-' + i;
      options[i].setAttribute('role', 'option');
    }

    var isOpen = this.isOpen();
    var hasOptions = options.length > 0;
    this.input.setAttribute('aria-expanded', isOpen && hasOptions ? 'true' : 'false');
    this.announce(options);
  }

  announce(options) {
    if (!this.liveRegion) return;
    var value = this.input.value.trim();
    if (options.length > 0) {
      this.liveRegion.textContent = options.length + ' search suggestions available. Use arrow keys to navigate.';
    } else if (value) {
      this.liveRegion.textContent = 'No search suggestions available.';
    } else {
      this.liveRegion.textContent = '';
    }
  }

  removeSelected() {
    if (!this.resultsContainer) return;
    var el = this.resultsContainer.querySelector('[aria-selected="true"]');
    if (el) el.removeAttribute('aria-selected');
  }

  selectOption(index) {
    var options = this.getSelectableOptions();
    if (index < 0 || index >= options.length) return;
    this.removeSelected();
    this.currentIndex = index;
    options[index].setAttribute('aria-selected', 'true');
    this.input.setAttribute('aria-activedescendant', options[index].id);
    if (this.liveRegion) {
      this.liveRegion.textContent = options[index].textContent.trim() + ', ' + (index + 1) + ' of ' + options.length;
    }
  }

  isOpen() {
    return this.wrapper && this.wrapper.classList.contains('active');
  }

  open() {
    if (!this.wrapper || !this.siteHeader) return;
    this.wrapper.classList.add('active');
    this.siteHeader.classList.add('search-active');
    var self = this;
    setTimeout(function() { self.input.focus(); }, 100);
    if (this.input.value.trim()) {
      this.showDynamicResults();
    }
    this.refreshOptions();
  }

  close() {
    if (!this.wrapper || !this.siteHeader) return;
    this.wrapper.classList.remove('active');
    this.siteHeader.classList.remove('search-active');
    this.input.setAttribute('aria-expanded', 'false');
    this.input.setAttribute('aria-activedescendant', '');
    this.removeSelected();
    this.currentIndex = -1;
    if (this.searchBtn) this.searchBtn.focus();
    this.showDefaultSuggestions();
  }

  showDefaultSuggestions() {
    if (this.defaultSuggestions) this.defaultSuggestions.classList.remove('dn-i');
  }

  showDynamicResults() {
    if (this.defaultSuggestions) this.defaultSuggestions.classList.add('dn-i');
  }

  setupAttributes() {
    this.input.setAttribute('role', 'combobox');
    this.input.setAttribute('aria-expanded', 'false');
    this.input.setAttribute('aria-haspopup', 'listbox');
    this.input.setAttribute('aria-autocomplete', 'list');
    this.input.setAttribute('aria-controls', 'search-results-listbox');

    if (this.resultsContainer) {
      this.resultsContainer.setAttribute('id', 'search-results-listbox');
      this.resultsContainer.setAttribute('role', 'listbox');
      this.resultsContainer.setAttribute('aria-label', 'Search suggestions');
    }
  }

  setupEventListeners() {
    var self = this;

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && self.isOpen()) {
        e.preventDefault();
        self.close();
      }
    });

    if (this.searchBtn) {
      this.searchBtn.addEventListener('click', function(e) {
        e.preventDefault();
        self.open();
      });
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', function() {
        self.close();
      });
    }

    this.input.addEventListener('input', function() {
      var value = this.value.trim();
      if (value) {
        if (self.defaultSuggestions) self.defaultSuggestions.classList.add('dn-i');
      } else {
        self.defaultSuggestions && self.defaultSuggestions.classList.remove('dn-i');
        if (self.liveRegion) self.liveRegion.textContent = '';
      }
    });

    this.input.addEventListener('keydown', function(e) {
      var options = self.getSelectableOptions();

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (!options.length) return;
          var next = self.currentIndex < options.length - 1 ? self.currentIndex + 1 : 0;
          self.selectOption(next);
          this.setAttribute('aria-expanded', 'true');
          break;

        case 'ArrowUp':
          e.preventDefault();
          if (!options.length) return;
          var prev = self.currentIndex > 0 ? self.currentIndex - 1 : options.length - 1;
          self.selectOption(prev);
          this.setAttribute('aria-expanded', 'true');
          break;

        case 'Enter':
          if (self.currentIndex >= 0 && self.currentIndex < options.length) {
            e.preventDefault();
            options[self.currentIndex].click();
          }
          break;
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  var bars = document.querySelectorAll('.search-bar-container-custom');
  for (var i = 0; i < bars.length; i++) {
    new SearchBarA11y(bars[i]);
  }
});
